export default __webpack_public_path__ + "a29f7c9106c8bc1f56fb1d7937466dae.svg";